import {
  ForwardedRef,
  forwardRef,
  ForwardRefExoticComponent,
  FunctionComponent,
  PropsWithoutRef,
  RefAttributes,
  useMemo,
} from 'react';

import { StoresProvider } from '@/common/components/StoresProvider/StoresProvider';
import globalStore, { Store } from '@/store';

export function withStores<T, R = unknown>(
  stores: (store: Store, props: T) => Record<string, unknown>,
  Component: FunctionComponent<T> | ForwardRefExoticComponent<PropsWithoutRef<T> & RefAttributes<R>>,
) {
  const ComponentWithRef = Component as ForwardRefExoticComponent<PropsWithoutRef<T> & RefAttributes<R>>;

  return forwardRef(function withStoreComponent(props: PropsWithoutRef<T>, ref: ForwardedRef<R>) {
    const store = useMemo(() => stores(globalStore, props as T), []);

    return (
      <StoresProvider stores={store}>
        <ComponentWithRef {...props} ref={ref} />
      </StoresProvider>
    );
  });
}
